import commonService from '@common/services';

export default (shareConfig, fn) => {
    const wx = window.wx;
    if (!wx) {
        return;
    }
    const url = window.location.href;
    commonService.getWechatConfig(url)
        .then(data => {
            if (data) {
                const params = {
                    debug: false,
                    appId: data.data.appId,
                    timestamp: data.data.timestamp,
                    nonceStr: data.data.nonceStr,
                    signature: data.data.signature,
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
                };
                wx.config(params);
                wx.ready(() => {
                    // 1.4.0
                    // wx.updateAppMessageShareData(shareConfig);
                    // wx.updateTimelineShareData(shareConfig);
                    // 1.2.0
                    wx.onMenuShareTimeline(shareConfig);
                    wx.onMenuShareAppMessage(shareConfig);
                    wx.onMenuShareQQ(shareConfig);
                    wx.onMenuShareWeibo(shareConfig);
                    wx.onMenuShareQZone(shareConfig);

                    fn && fn();
                });
                wx.error(res => {
                    console.log(res);
                });
            }
        }).catch(err => {
            console.error(err);
        });
};
